// src/pages/admin/DividedPaymant.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";

// ฟอร์ม “เชิญประชุมอนุมัติจ่ายเงินปันผล”
import DividendPaymentForm from "../../forms/meeting/Meeting Invitation for Dividend Payment/MeetingInvitationforDividendPayment";

function DividedPaymantPage() {
  return (
    <FormWrapper
      title="เชิญประชุมอนุมัติการจ่ายเงินปันผล"
      FormComponent={DividendPaymentForm}
      formKey="dividend-payment"
    />
  );
}

export default DividedPaymantPage;
